import { type FC } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import Favorite from 'dibs-icons/exports/Favorite.ts';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';

import dibsCss from 'dibs-css';
import styles from './SbSharedFavoritesNudgeToast.scss';

const SbSharedFavoritesNudgeToastContent: FC = () => {
    const { isItemFavoritingFeb2026Variant } = useServerVarsContext();

    return (
        <div
            className={classNames(
                styles.toastContent,
                dibsCss.relative,
                dibsCss.zBump,
                dibsCss.bgWhite,
                dibsCss.pSmaller,
                isItemFavoritingFeb2026Variant && [
                    styles.toastContentDesktop,
                    dibsCss.borderWarningprimary,
                    dibsCss.border2,
                    dibsCss.borderSolid,
                    dibsCss.bgTangerine50,
                ]
            )}
        >
            <div
                className={classNames(
                    dibsCss.flex,
                    dibsCss.justifyBetween,
                    dibsCss.gapSmaller,
                    isItemFavoritingFeb2026Variant && [dibsCss.prSmaller, dibsCss.itemsCenter]
                )}
            >
                <div
                    className={classNames(
                        styles.iconWrapper,
                        dibsCss.flex,
                        dibsCss.itemsCenter,
                        dibsCss.justifyCenter,
                        dibsCss.roundedFull,
                        dibsCss.bgTangerine50,
                        dibsCss.fillWarningprimary,
                        isItemFavoritingFeb2026Variant && styles.iconWrapperDesktop
                    )}
                >
                    <Favorite variation={isItemFavoritingFeb2026Variant ? '40' : '24'} />
                </div>
                <div
                    className={classNames(
                        dibsCss.flex,
                        dibsCss.flexCol,
                        dibsCss.gap2px,
                        dibsCss.mrAuto,
                        !isItemFavoritingFeb2026Variant && dibsCss.maxW250px
                    )}
                >
                    <span
                        className={classNames(
                            dibsCss.sassyFontBodySmallHeavy,
                            dibsCss.textNoir,
                            isItemFavoritingFeb2026Variant && dibsCss.sassyFontBodyMediumHeavy
                        )}
                    >
                        <FormattedMessage
                            id="abf.SbSharedFavoritesNudgeToastContent.title"
                            defaultMessage="Save items you love!"
                        />
                    </span>
                    <span className={classNames(dibsCss.sassyFontBodySmall, dibsCss.textCharcoal)}>
                        <FormattedMessage
                            id="abf.SbSharedFavoritesNudgeToastContent.body"
                            defaultMessage="{isItemFavoritingFeb2026Variant, select,
                                true {Be the first to know when the price drops.}
                                other {Track price drops and get exclusive offers for your favorited items.}
                            }"
                            values={{
                                isItemFavoritingFeb2026Variant,
                            }}
                        />
                    </span>
                </div>
            </div>
        </div>
    );
};

export { SbSharedFavoritesNudgeToastContent };
